module.exports = __webpack_public_path__ + "assets/ic-calendar.61ffb688.svg";